module.exports = __webpack_public_path__ + "img/mc-app-supplier.a3a5468c.png";